import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { getIcon } from "@/lib/iconRegistry";

const ICON_COLORS = ["#b1976b", "#0f6e6e", "#8b4b3b", "#3c5a7a", "#6b7a3f", "#8a5a9e", "#a8763f", "#4a6b6b", "#7a4a5a"];

export default function ServiceGrid() {
  const [services, setServices] = useState([]);
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/services").then((res) => setServices(res.data)).catch(() => {});
    api.get("/site-settings").then((res) => setContent(res.data.homepage_content?.service_grid || {})).catch(() => {});
  }, []);

  return (
    <section data-testid="service-grid-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span data-testid="service-grid-overline" className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">{content.overline || "Our Services"}</span>
          <h2 data-testid="service-grid-title" className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mt-3">{content.title || "Complete Gulf Visa & Travel Solutions"}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = getIcon(s.icon);
            const accent = ICON_COLORS[i % ICON_COLORS.length];
            return (
              <div key={s.slug} data-testid={`service-card-${s.slug}`} style={{ "--service-accent": accent }}
                className="group p-7 rounded-lg border border-[#E5E1DA] bg-[#FDFCFB] hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
                >
                <div className="w-14 h-14 rounded-full bg-[color-mix(in_oklab,var(--service-accent),transparent_88%)] flex items-center justify-center mb-5 group-hover:bg-[var(--service-accent)] transition-colors">
                  <Icon size={24} className="text-[var(--service-accent)] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading text-xl text-[#1A1A1A] mb-2">{s.name}</h3>
                <p className="text-sm text-[var(--brand-secondary)] leading-relaxed mb-5 line-clamp-2">{s.short_description}</p>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-link-${s.slug}`}>
                  <Button variant="link" className="text-[var(--service-accent)] p-0 h-auto font-medium">
                    {content.button_text || "Learn More"} <ArrowRight size={16} className="ml-1" />
                  </Button>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
